<!--
 * @Author: 协议
 * @Date: 2021-09-27 10:17:26
 * @LastEditTime: 2021-11-19 17:25:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \h5-vip\src\pages\agreement\index.vue
-->
<template>
  <div class="app-container">
    <div class="agreement" v-html="html"></div>
  </div>
</template>

<script>
import { getRegisteredAgreement } from "@/api/index";
// import { Toast } from "vant";
export default {
  data() {
    return {
      html: "",
    };
  },
  created() {
    this.getAgreement();
  },
  methods: {
    async getAgreement() {
      await getRegisteredAgreement({ articleTypes: [15] })
        .then((res) => {
          this.html = res.data[0].content;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.app-container {
  width: 100%;
}
.agreement {
  padding: 8px 10px;
}
</style>
